import React from 'react';
import logo from '../../../../images/logo_purple.png';
import boxImage from '../../../../images/boxImage.png';
import boxUser from '../../../../images/boxUser.png';
import { CustomLabel } from "@tracknme/material-ui";
import '../../../../menu.css'

function MenuLeftStep1(propos) {

  return (
    
        <div>
           <img src={logo} className="logo" alt="logo" />
          
           <div className="titleStep1" >
             {!propos.isUser ?(
                <CustomLabel id="labe_1" label="Tenha acesso a todos os produtos da Track’n Me!" color="initial" component="h6" variant="h6" style={{fontSize:16.2, fontWeight:600}} />  
             ):(
                <CustomLabel id="labe_1" label="Tenha acesso a todos rastreadores compartilhados com você!" color="initial" component="h6" variant="h6" style={{fontSize:12.2, fontWeight:600}} /> 
             )}
           
           </div>

           <div className="subtitle" >
            {!propos.isUser ?(
               <CustomLabel id="subtitle" label="Tenha tudo o que você precisa para operar sua empresa de rastreamento, incluindo sistema de cobrança." color="initial" component="h6" variant="h6" style={{fontSize:12.8, fontWeight:400, color:"#888888"}} />
            ):(
              <>
              <CustomLabel id="subtitle" label="Você poderá acompanhar os rastreadores compartilhados." color="initial" component="h6" variant="h6" style={{fontSize:12.8, fontWeight:400, color:"#888888"}} /> 
              <CustomLabel id="subtitle" label="Relatórios de acompanhamento." color="initial" component="h6" variant="h6" style={{fontSize:12.8, fontWeight:400, color:"#888888", marginTop:10}} /> 
              <CustomLabel id="subtitle" label="Você terá relatórios disponíveis para apurar rotas utilizadas e kilometragem percorrida por dia." color="initial" component="h6" variant="h6" style={{fontSize:12.8, fontWeight:400, color:"#888888", marginTop:10}} /> 
             
              </> 
            )}
           </div>

           
           {!propos.isUser ?(
              <img src={boxImage} className="boxImage" alt="logo" />
           )
           :(
              <img src={boxUser} className="boxImage" alt="logo" /> 
            )
            }
        </div>
  );
}

export default MenuLeftStep1;

